import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    width: 'auto',
    cursor: 'pointer',
  },
  option: {
    fontSize: 16,
  },
  optionActiveFontWeight: {
    backgroundColor: props => (props.font_weight ? theme.palette.action.selected : ''),
  },
  optionActiveFontStyle: {
    backgroundColor: props => (props.font_style ? theme.palette.action.selected : ''),
  },
  optionActiveTextDeco: {
    backgroundColor: props => (props.text_decoration ? theme.palette.action.selected : ''),
  },
}))

export default useStyles
